import React from "react";
import Languages from "../Utils/Languages";

const Number = ({ prop }) => {
    const [inputValue, setInputValue] = React.useState(prop.value || "");
    const { title, required } = prop;
    return (
        <input
            name={title}
            type="number"
            value={inputValue}
            required={required}
            // autoFocus={autoFocus}
            placeholder={Languages[title] || title}
            onChange={({ target }) => {
                let text = target.value;
                prop.value = text;
                setInputValue(text);
            }}
            className="popup-card outline-none"
        />
    );
};

export default Number;
